export const nav = {
  dashboard: 'Vezérlőpult',
  customers: 'Ügyfelek',
  customerGroups: 'Ügyfélcsoportok',
  documentStorage: 'Könyvtár',
  documentLibrary: 'Könyvtár',
  suppliers: 'Beszállítók',
  notes: 'Cetlik',
  richNotes: 'Jegyzetfüzet',
  appointments: 'Időpontfoglalás',
  customerPortal: 'Ügyfélportál',
  missingItems: 'Hiánylista',
  customerRelationshipLogs: 'Ügyfélkapcsolati napló',
  products: 'Termékek',
  categories: 'Kategóriák',
  warehouse: 'Raktárak',
  inventory: 'Készlet',
  warranty: 'Garancia',
  offers: 'Árajánlatok',
  ai_quotations: 'AI Árajánlatok',
  deals: 'Ügyletek',
  contracts: 'Dokumentumok',
  worksheets: 'Munkalapok',
  reports: 'Jelentések',
  settings: 'Beállítások',
  profile: 'Profil',
  system_admin: 'Rendszergazda',
  storageOptimization: 'Storage Optimalizálás',
  templates: 'Sablonok',
  documentVariables: 'Változók',
  formBuilder: 'Űrlapok és Listák',
  formBuilderEditor: 'Form Builder',
  flowBuilder: 'Flow Builder',
  myForms: 'Saját Űrlapok',
  workPagesTemplates: 'Kitöltendő munkalap',
  filledWorkpage: 'Kitöltött munkalap',
  billing: 'Számlázás',
  billingSubtitle: 'Számlák, díjbekérők és jóváírások kezelése',
  tasks: 'Feladatok',
  tasksSubtitle: 'Feladatok és teendők kezelése',
  projects: 'Projektek',
  projectsSubtitle: 'Projektek kezelése és nyomon követése',
  projectBoard: 'Projekt Board',
  pipeline: 'Pipeline',
  quotations: 'Árajánlatok',
  orders: 'Megrendelések',
  delivery_notes: 'Szállítólevelek',
  sales: 'Értékesítés',
  organization: 'Szervezet',
  selectOrganization: 'Válassz szervezetet',
  vehicles: 'Járművek',
  bookings: 'Foglalások',
  customerVehicles: 'Ügyfél Járművei',
  galleries: 'Galériák',
  vehicleSettings: 'Járműbeállítások',
  maintenance: 'Karbantartás & Szerviz',
  fuel: 'Üzemanyag kezelés',
  documents: 'Dokumentumok',
  expenses: 'Költségek',
  fleetReports: 'Riportok & Elemzések',
  groups: {
    crm: 'CRM & Kapcsolatok',
    products: 'Termékek & Készlet',
    sales: 'Értékesítés & Rendelések',
    documents: 'Dokumentumok',
    contracts: 'Szerződések',
    forms: 'Űrlapok',
    processes: 'Folyamatok',
    projects: 'Projektek & Feladatok',
    finance: 'Pénzügyek',
    fleet: 'Flottakezelés'
  },
  expandSidebar: 'Oldalsáv kibontása',
  collapseSidebar: 'Oldalsáv összecsukása'
}